export class Config {
  static URL = import.meta.env.VITE_URL
  static ENV = import.meta.env.MODE || 'development'
  static PREVIEW = /[?&]x-craft-live-preview/.test(location.search)
  static LOADER = false
  static ANIMS_ABOVE_THE_FOLD = false
  static URLPARAMS = new URLSearchParams(location.search)
  static DEV = import.meta.env.DEV
  static DEBUG = /[?&]debug/.test(location.search)
  static SMOOTH = true
  static MOBILE = false
  static DRAG = false
  static BREAKPOINTS = {
    MD: 800,
    LG: 1000,
    XL: 1250,
    XXL: 1450,
  }
}
